import { ConfigT } from "ui-io/config-io";
import fetchApi from "ui-io/fetch-api";
import * as t from "io-ts";
type Props = {
	companyID: string;
	licence_no: string;
	body: ConfigT;
}


export const taskRunScrapeConfig = (props: ConfigT) => {
	return fetchApi({
		service: "octopus-service",
		method: "POST",
		headers: { "Content-Type": "application/json" },
		pathname: `/run-scrape`,
		codec: t.unknown,
		body: props,	
	});
};